<template>
  <div class="admin-container">
    <div class="header">
      <van-nav-bar title="管理后台" left-arrow @click-left="goBack" />
    </div>

    <div class="content">
      <div class="sidebar">
        <div class="sidebar-item active" @click="goToUpload">
          <van-icon name="description" size="20" />
          <span>批量上传</span>
        </div>
        <div class="sidebar-item" @click="goToQuestions">
          <van-icon name="list-switch" size="20" />
          <span>题目列表</span>
        </div>
        <div class="sidebar-item" @click="goToUsers">
          <van-icon name="friends" size="20" />
          <span>用户管理</span>
        </div>
        <div class="sidebar-item" @click="goToWxpayConfig">
          <van-icon name="setting-o" size="20" />
          <span>系统设置</span>
        </div>
      </div>

      <div class="main-content">
        <div class="admin-info" v-if="user">
          <div class="info-card">
            <van-icon name="user-circle-o" size="48" />
            <div class="info-text">
              <h3>{{ user.nickname || '管理员' }}</h3>
              <p>权限等级：{{ user.vip_level }}级</p>
            </div>
          </div>
        </div>

        <div class="admin-menu">
          <div class="menu-section">
            <h3>题目管理</h3>
            <div class="menu-item" @click="goToUpload">
              <van-icon name="description" size="24" color="#1890ff" />
              <div class="menu-text">
                <h4>批量上传题目</h4>
                <p>导入Excel或CSV格式的题目</p>
              </div>
              <van-icon name="arrow" />
            </div>
            <div class="menu-item" @click="goToQuestions">
              <van-icon name="list-switch" size="24" color="#52c41a" />
              <div class="menu-text">
                <h4>题目列表</h4>
                <p>查看和管理所有题目</p>
              </div>
              <van-icon name="arrow" />
            </div>
          </div>

          <div class="menu-section">
            <h3>用户管理</h3>
            <div class="menu-item" @click="goToUsers">
              <van-icon name="friends" size="24" color="#722ed1" />
              <div class="menu-text">
                <h4>用户列表</h4>
                <p>查看和管理用户信息</p>
              </div>
              <van-icon name="arrow" />
            </div>
          </div>

          <div class="menu-section">
            <h3>系统设置</h3>
            <div class="menu-item" @click="goToWxpayConfig">
              <van-icon name="setting-o" size="24" color="#faad14" />
              <div class="menu-text">
                <h4>支付配置</h4>
                <p>配置微信支付参数</p>
              </div>
              <van-icon name="arrow" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Toast } from 'vant'

export default {
  name: 'Admin',
  data() {
    return {
      user: null
    }
  },
  computed: {
    ...mapGetters(['isVip'])
  },
  mounted() {
    this.checkAdminPermission()
    this.user = this.$store.state.user
  },
  methods: {
    checkAdminPermission() {
      const user = this.$store.state.user
      if (!user || user.vip_level < 3) {
        Toast.fail('权限不足，需要管理员权限')
        setTimeout(() => {
          this.$router.back()
        }, 1500)
      }
    },
    goBack() {
      this.$router.back()
    },
    goToUpload() {
      this.$router.push('/admin/upload')
    },
    goToQuestions() {
      Toast('题目列表功能开发中')
    },
    goToUsers() {
      Toast('用户列表功能开发中')
    },
    goToWxpayConfig() {
      this.$router.push('/admin/wxpay/config')
    }
  }
}
</script>

<style scoped>
.admin-container {
  min-height: 100vh;
  background: #f8f9ff;
  padding-bottom: calc(60px + env(safe-area-inset-bottom));
}

.header {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.content {
  padding: 20px;
  display: flex;
  gap: 20px;
}

.sidebar {
  width: 120px;
  flex-shrink: 0;
}

.sidebar-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  border-radius: 8px;
  background: white;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.3s;
  color: #666;
  font-size: 14px;
}

.sidebar-item.active {
  background: #764ba2;
  color: white;
}

.sidebar-item:active {
  transform: scale(0.98);
}

.sidebar-item .van-icon {
  flex-shrink: 0;
}

.sidebar-item span {
  flex: 1;
}

.main-content {
  flex: 1;
  min-width: 0;
}

.admin-info {
  margin-bottom: 24px;
}

.info-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: white;
  box-shadow: 0 4px 16px rgba(118, 75, 162, 0.3);
}

.info-card .van-icon {
  flex-shrink: 0;
}

.info-text h3 {
  margin: 0 0 4px 0;
  font-size: 18px;
  font-weight: 600;
}

.info-text p {
  margin: 0;
  font-size: 14px;
  opacity: 0.9;
}

.admin-menu {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.menu-section {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.menu-section h3 {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a2e;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 12px;
  background: #f8f9ff;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-item:last-child {
  margin-bottom: 0;
}

.menu-item:active {
  transform: scale(0.98);
  background: #e8f0ff;
}

.menu-item .van-icon:first-child {
  flex-shrink: 0;
  margin-right: 12px;
}

.menu-text {
  flex: 1;
  min-width: 0;
}

.menu-text h4 {
  margin: 0 0 4px 0;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a2e;
}

.menu-text p {
  margin: 0;
  font-size: 13px;
  color: #999;
}

.menu-item .van-icon:last-child {
  flex-shrink: 0;
  color: #ccc;
}
</style>
